import { ChangeDetectorRef, Component, TemplateRef, ViewChild } from '@angular/core';
import { ToggleRendererComponent } from '../reusable/toggle-reusable/toggle-reusable.component';
import { ClientSideRowModelModule, ColumnApiModule, DateFilterModule, GridApi, GridReadyEvent, ModuleRegistry, NumberFilterModule, PaginationModule, RenderApiModule, RowDragModule, RowSelectionModule, TextFilterModule, TooltipModule, ValidationModule } from 'ag-grid-community';
import { ApiService } from '../../services/api.service';
import { BsModalRef, BsModalService, ModalModule } from 'ngx-bootstrap/modal';
import { ToastrModule, ToastrService } from 'ngx-toastr';
import { CreateTagComponent } from './create-tag/create-tag.component';
import { CreatePermissionComponent } from '../manage-permission/create-permission/create-permission.component';
import { CreateScopeComponent } from '../manage-scope/create-scope/create-scope.component';
import { CreateResourceComponent } from '../manage-resource/create-resource/create-resource.component';
import { ConfirmDialogComponent } from '../reusable/confirm-dialog/confirm-dialog.component';
import { AgGridAngular } from 'ag-grid-angular';
import { CommonModule } from '@angular/common';
import { CreateOrganisationComponent } from '../manage-organisation/create-organisation/create-organisation.component';
import { CreateBranchComponent } from '../manage-branches/create-branch/create-branch.component';
import { CreateUserComponent } from '../manage-user/create-user/create-user.component';


ModuleRegistry.registerModules([
  ClientSideRowModelModule,
  TextFilterModule,
  NumberFilterModule,
  DateFilterModule,
  PaginationModule,
  RowSelectionModule,
  RowDragModule,
  TooltipModule,
  ColumnApiModule,
  ValidationModule
]);
@Component({
  selector: 'app-manage-tag',
  imports: [CommonModule, AgGridAngular, ModalModule, ToastrModule, ConfirmDialogComponent],
  templateUrl: './manage-tag.component.html',
  styleUrl: './manage-tag.component.scss',
  providers: [BsModalService]

})
export class ManageTagComponent {

@ViewChild('cellTemplate', { static: true }) cellTemplate!: TemplateRef<any>;
  @ViewChild(AgGridAngular) agGrid!: AgGridAngular;
@ViewChild(ConfirmDialogComponent) confirmDialog!: ConfirmDialogComponent;
gridApi!: GridApi;
modalRef?: BsModalRef;
selectedRowData: any;
rowData: any
columnDefs: any = [
    {
      field: 'id', hide: true 
    },
    {
      headerName: 'Tag Name', field: 'name', tooltipField: 'name', tooltipValueGetter: (params: any) => params.value || 'No data', flex: 1,  sortable: true
    },
    {
      headerName: 'Slug', tooltipField: 'slug', field: 'slug', tooltipValueGetter: (params: any) => params.value || 'No data',  flex: 1
    },
    // {
    //   headerName: 'Status', field: 'deleted', tooltipField: 'deleted', valueGetter: (params: any) => params.data.deleted ? 'Active' : 'Disable', flex: 1
    // },
    // {
    //   headerName: 'Deleted',
    //   field: 'deleted',
    //   cellRenderer: ToggleRendererComponent,
    //   flex: 1,
    //   sortable: false,
    //   filter: false,
    // },
    {
      headerName: 'Actions',
      field: 'actions',
      cellRenderer: (params: any) => {
        return this.getHtml(params);
      },
      sortable: false,
      filter: false,
      flex: 1
    }
  ];
  
    modules = [ClientSideRowModelModule, ValidationModule, PaginationModule, RowSelectionModule, RowDragModule, TooltipModule, RenderApiModule,ColumnApiModule ];
    pagination = true;
    paginationPageSizeSelector = [5, 10, 25, 50, 100];
    paginationPageSize = 10;

    gridOptions = {
    suppressMovableColumns: false,
    rowDragManaged: false,
    animateRows: true,
    enableBrowserTooltips: true,
  };
  

  



   constructor(
    private apiService: ApiService,
    private modalService: BsModalService,
    private toastr: ToastrService,
    private cdr: ChangeDetectorRef,
  ) { }
  ngOnInit(): void {
    
    this.getTags();
  }

  onGridReady(params: GridReadyEvent) {
      this.gridApi = params.api;
      this.gridApi.setGridOption('context', { componentParent: this });
       this.gridApi.applyColumnState({
        state: [{ colId: 'id', sort: 'desc' }],
        defaultState: { sort: null },
      });
      //  this.addPageSizeSelectorToFooter();
    }
    editRow(rowData: any) {
    console.log('rowData', rowData);
    this.openModal(rowData);
  }

  deleteRow(rowData: any) {
    this.selectedRowData = rowData;
    this.confirmDialog.openModal(rowData);

  }

   onConfirmDelete() {
    if (!this.selectedRowData) return;
    this.apiService.delete(`tag/${this.confirmDialog.rowData.id}`).subscribe({
      next: (res: any) => {
        if(res.statusCode == 409){
          this.toastr.error(res.message, 'Error');
        }
        else{
          this.toastr.success('Tag deleted successfully!', 'Success');
        }
        this.getTags();
      },
      error: (err: any) => {
        console.error('Error deleting tag:', err);
        this.toastr.error(err.error?.message || 'Failed to delete tag.', 'Error');
      }
    });
  }

  openModal(rowData = '') {
      this.modalRef = this.modalService.show(CreateTagComponent, {
        class: 'modal-lg my-custom-class',
        initialState: {
          tagData: rowData,
          parentPage: 'Tag',
        }
      });
      (this.modalRef.content as CreateTagComponent).modalClosed.subscribe(() => {
        console.log('Modal Closed now refresh the list');
        this.getTags();
      });
    }
   getHtml(params: any) {
    const view = this.cellTemplate.createEmbeddedView({
      rowData: params.data,
    });
    view.detectChanges();
    const div = document.createElement('div');
    if (view.rootNodes.length > 0) {
      div.appendChild(view.rootNodes[0]);
      return div;
    } else {
      console.error('view.rootNodes is empty');
      return '';
    }
  }

  openOrganisationModal() {
      this.modalRef = this.modalService.show(CreateOrganisationComponent, {
        class: 'modal-lg my-custom-class',
        backdrop: true,
        ignoreBackdropClick: true,
        keyboard: false,
        animated: true,
         initialState: {
         parentPage: 'Tag',
        }
      });
    }

    getTags(): void {
    this.apiService.get('tag').subscribe({
      next: (res: any) => {
        this.rowData = res.data;
        if (this.agGrid) {
          this.agGrid.api.refreshCells({ force: true });
        }
      },
      error: (err) => {
        console.log(err);
      }
    })
  }
    openBranchModal() {
      this.modalRef = this.modalService.show(CreateBranchComponent, {
        class: 'modal-lg my-custom-class',
        backdrop: true,
        ignoreBackdropClick: true,
        keyboard: false,
        animated: true,
         initialState: {
         parentPage: 'Tag',
        }
      });
    }
    openUserModal() {
      this.modalRef = this.modalService.show(CreateUserComponent, {
        class: 'modal-lg my-custom-class',
        backdrop: true,
        ignoreBackdropClick: true,
        keyboard: false,
        animated: true,
         initialState: {
         parentPage: 'Tag',
        }
      });
    }
  
}
